$(window).on("load", function () {
    function getYoutubeId(url) {
        var match = String(url || '').match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
        return match ? match[1] : '';
    }

    $('#prjx5-ld-26-at2-swiper .swiper-slide').each(function () {
        var $slide = $(this);
        var youtubeUrl = $slide.attr('href');
        var videoId = getYoutubeId(youtubeUrl);
        var $img = $slide.find('img').first();

        if (!videoId || !$img.length) {
            return;
        }

        var thumbnail = 'https://img.youtube.com/vi/' + videoId + '/hqdefault.jpg';

        $img.attr({
            'src': thumbnail,
            'data-src': thumbnail
        });
    });

    var swiper = new Swiper(".mySwiper", {
        effect: "fade",
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
        },
    });
});
